import React from "react";
import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, ButtonGroup, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import ReactTable from "react-table";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Edit from '@material-ui/icons/Edit'
import moment from "moment";
import APPCONFIG from "../../constants/Config";
import Check from "@material-ui/icons/Check";
import Clear from "@material-ui/icons/Clear";
import Checkbox from "@material-ui/core/Checkbox";
import {Collections} from "../index";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";
import FormControlLabel from "@material-ui/core/FormControlLabel";

export default class Financial_Approvals extends Framework.Components.Collection {
	//Pay Center Admin route pay_center_admin approve/reject
	constructor(props) {
		let model = new API.BuildClass(Types.Financials_Invoice._name, API.RequestType.READ_ALL);
		super(props, model);
		this.request = 'GET_ADMIN';
		this.state.limit = 16;
		this.state.user = [];
		this.state.selectedUsers = [];
		this.state.filterDate = this.props.initialDate ? moment(this.props.initialDate).format('YYYY-MM-DD') : moment().day(0).format('YYYY-MM-DD');
		this.state.filterStatus = false;
		this.state.useDateFilter = false;
	}

	fetchData = async (state) => {
		this.state.sorted = [];
		this.state.page = 0;
		if (typeof (this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		this.state.filter.filterUsers = this.state.selectedUsers;
		this.state.filter.filterDate = this.state.useDateFilter === true ? this.state.filterDate : null;
		this.state.filter.filterStatus = this.state.filterStatus;
		this.setState({loading: true});
		await this.fetchDataActual(state);
	}

	handleApproval = async (pkey) => {
		//approve
		let invoice = new API.BuildClass(Types.Financials_Invoice._name, API.RequestType.UPDATE);
		invoice.object.pkey = pkey;
		await invoice.submit(null, 'POST_APPROVE');
		await this.fetchData();
	}

	handleRejection = async () => {
		//reject
		let invoice = new API.BuildClass(Types.Financials_Invoice._name, API.RequestType.UPDATE);
		invoice.object.pkey = this.state.selectedPkey;
		invoice.object.notes = this.state.notes;
		await invoice.submit(null, 'POST_REJECT');
		await this.fetchData();
	}

	handleToggleModal = (modal) => {
		this.setState({[modal]: !this.state[modal]})
	}

	handleSelectPropertyUpdate = async (property, value, linked, object) => {
		this.setState({
			[property]: value,
			[property + '_error']: '',
			selectedUsers: [...value].filter((value, index, self) => self.indexOf(value) === index),
		}, () => {this.fetchData(this.state).then()});
	};

	render() {
		const {data, pages, limit, loading} = this.state;
		let object = this.state;
		/** @type {Financials_Invoice_Properties} properties */
		let properties = this.model.properties;
		const columns = [
			{
				Header: "Name",
				accessor: "users_name",
			},
			{
				Header: "Week",
				id: "week_start_date",
				/** @param {Financials_Object} obj */
				accessor: obj => moment(obj.week_start_date).format('MM/DD/YYYY')
			},
			{
				Header: "Base Pay",
				id: "base_pay",
				/** @param {Financials_Object} obj */
				accessor: obj => (obj.base_pay)
			},
			{
				Header: "Commission",
				accessor: "commission",
			},
			{
				Header: "Travel Fee",
				accessor: "gas_credits",
			},
			{
				Header: "Feedback",
				accessor: "feedback",
			},
			{
				Header: "Hardware",
				accessor: "hardware",
			},
			{
				Header: "Bonus",
				id: "bonus",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 100,
				accessor: obj => obj.bonus,
				Cell: props => {
					return (
						<div style={{textAlign: 'center'}}>
							<Checkbox
								checked={!!props.original.bonus}
								disabled={true}
								color={'primary'}
							/>
						</div>
					);
				}
			},
			{
				Header: "Total - Hardware",
				id: "total_minus_hardware",
				accessor: obj => (parseFloat(obj.total_pay) - parseFloat(obj.hardware)).toFixed(2)
			},
			{
				Header: "Total Pay",
				accessor: "total_pay",
			},
			{
				Header: "Notes",
				accessor: "notes",
				style: {
					whiteSpace: "normal", // Allow text to wrap
					wordWrap: "break-word",
				},
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 60,
				Cell: props => {
					let url = APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + "/forms/results/invoice/" + props.original.pkey;

					return (
						<span>
							<Button color="info" size={"sm"} onMouseDown={() => window.open(url, "_blank")} block={true}>
								View
							</Button>
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				Cell: props => {
					return (
						<span>
							<Button color="green-meadow" size={"sm"} onMouseDown={() => {
								//Approve
								this.handleApproval(props.original.pkey)
							}} block={true}>
								<Check fontSize={'small'}/>
							</Button>
						</span>
					);
				}
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 45,
				Cell: props => {
					return (
						<span>
							<Button color="danger" size={"sm"} onMouseDown={() => {
								//Reject
								this.setState({selectedPkey: props.original.pkey, showNotesModal: true})
							}} block={true}>
								<Clear fontSize={'small'}/>
							</Button>
						</span>
					);
				}
			},
			{
				Header: "Approved/Rejected",
				id: "approved",
				width: 170,
				/** @param {Financials_Object} obj */
				accessor: obj => obj.rejected === true ? 'Rejected' : (obj.approved === true ? 'Approved' : 'Pending'),
			},
			{
				Header: "Submit Datetime",
				id: "created",
				accessor: obj =>
					moment(obj.created).tz('America/Phoenix').format('MM/DD/YYYY hh:mm'),
				minWidth: 150,
			},
		];

		return (
			<Card>
				<div className="rbc-toolbar pl-3 flex flex-col sm:flex-row sm:items-center sm:justify-between pb-0">
					<div className="flex gap-1">
						<IconButton disabled={this.state.filterDate === moment().day(0).format("YYYY-MM-DD") && this.props.id} onClick={async () => {
							this.setState({filterDate: moment(this.state.filterDate).subtract(7, 'day').day(0).format('YYYY-MM-DD')}, async () => {
								await this.fetchData(this.state);
							})
						}}><LeftArrowIcon/></IconButton>
						<button className="rbc-today" style={{width: 'auto'}} type="button" onClick={async () => {
							this.setState({filterDate: moment(Date.now()).day(0).format('YYYY-MM-DD')}, async () => {
								await this.fetchData(this.state);
							})
						}}>This Week
						</button>
						<IconButton onClick={async () => {
							this.setState({filterDate: moment(this.state.filterDate).add(7, 'day').day(0).format('YYYY-MM-DD')}, async () => {
								await this.fetchData(this.state);
							})
						}}><RightArrowIcon/></IconButton>
						<FormControlLabel
							control={<Checkbox
								checked={this.state.useDateFilter === true}
								onClick={async () => {
									this.setState({useDateFilter: !this.state.useDateFilter}, async () => {await this.fetchData();})
								}}
								color={'primary'}
							/>}
							label="Apply Week Filter"
						/>

					</div>
					<div className={"rbc-toolbar-label text-center sm:text-left"}>
						<label onClick={() => {
							this.handleToggleModal('showDate')
						}}>
							{moment(this.state.filterDate).format('ddd MMM D')} - {moment(this.state.filterDate).add(6, 'days').format('ddd MMM D')}
						</label>
					</div>
					<div style={{width: '33rem', zIndex: 999}}>
						<Framework.Elements.Select
							shouldLoad={true}
							update={this.handleSelectPropertyUpdate}
							property={properties.user}
							values={object.user}
							error={''}
							model={Types.Users._name}
							label={"Users"}
							limit={15}
							text={'name_first&name_last'}
							sort={'name_first|name_last'}
							isMulti

						/>
					</div>
				</div>

				<div className="table-bar" style={{paddingLeft: 15}}>
					<div className="d-flex">
						<ButtonGroup size={"md"}>
							<Button
								onClick={() => {
									this.setState({filterStatus: false}, async () => {
										await this.fetchData();
									})
								}}
								outline={!!this.state.filterStatus}
								active={this.state.filterStatus === false}
							>
								All
							</Button>
							<Button
								onClick={() => {
									this.setState({filterStatus: 'pending'}, async () => {
										await this.fetchData();
									})
								}}
								outline={this.state.filterStatus !== 'pending'}
								active={this.state.filterStatus === 'pending'}
								color={'primary'}
							>
								Pending
							</Button>
							<Button
								onClick={() => {
									this.setState({filterStatus: 'approved'}, async () => {
										await this.fetchData();
									})
								}}
								outline={this.state.filterStatus !== 'approved'}
								active={this.state.filterStatus === 'approved'}
								color={'info'}
							>
								Approved
							</Button>
							<Button
								onClick={() => {
									this.setState({filterStatus: 'rejected'}, async () => {
										await this.fetchData();
									})
								}}
								outline={this.state.filterStatus !== 'rejected'}
								active={this.state.filterStatus === 'rejected'}
								color={'info'}
							>
								Rejected
							</Button>
						</ButtonGroup>
						{this.renderHeaderRight(
							'Financials',
							columns,
						)}
					</div>
				</div>


				<Modal
					isOpen={this.state.showNotesModal}
					toggle={() => {
						this.setState({showNotesModal: false})
					}}
					size={"lg"}
					backdrop={true}
					style={{opacity: 1}}
				>
					<ModalHeader>
						Rejection Notes
					</ModalHeader>
					<ModalBody>
						<TextField
							fullWidth={true}
							size={"small"}
							label={"Notes"}
							value={this.state.notes}
							onChange={(e) =>
								this.setState({notes: e.currentTarget.value})}
							variant="outlined"
							multiline={true}
							rows={4}
						/>
					</ModalBody>
					<ModalFooter>
						<Button color="secondary" onClick={() => {
							this.setState({selectedPkey: null, showNotesModal: false, notes: ""})
						}}>Close</Button>
						<Button color="primary" onClick={async (event) => {
							await this.handleRejection();
							this.setState({selectedPkey: null, showNotesModal: false, notes: ""})
						}}>Reject</Button>
					</ModalFooter>
				</Modal>
				<CardContent>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
